export type LocationStateWithReturnTo = {
  returnTo?: string;
};

export const getReturnTo = <
  TState extends LocationStateWithReturnTo = LocationStateWithReturnTo,
>(
  state: unknown
): string | null => {
  if (!state || typeof state !== 'object') return null;

  const { returnTo } = state as TState;

  return typeof returnTo === 'string' && returnTo.length > 0 ? returnTo : null;
};
